import { useState } from "react";
import {
  CONFIGURATION_PREPEND,
  CONFIGURATION_ROUTER_URL,
  FACULTY_PREPEND,
  FACULTY_ROUTER_URL,
  ROUTER_URL,
  STAFF_PREPEND,
  STAFF_ROUTER_URL,
} from "../../constants/routerUrl";
import { connect } from "react-redux";
import { logoutUser } from "../../action/common/keyClaokActionCreator";
import { IAdminUserInfo } from "../../models/common/IUserProfile";
import { NavLink, useLocation } from "react-router-dom";
import { UserTypes } from "../../models/dashboard/adminDashboard";
import { collegeType } from "../../constants/collegeType";

const DepartmentAdminMenu = (props: IAdminUserInfo) => {
  const [] = useState(ROUTER_URL.DEPARTMENT_ADMIN_DASHBOARD);
  const { user, logout } = props;
  const location = useLocation();
  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <>
      <ul className="accordion-menu">
        <li>
          <NavLink
            to={ROUTER_URL.DEPARTMENT_DETAILS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="assets/images/icon/teacher.svg" alt="" />
            Department
          </NavLink>
        </li>
        <li>
          <NavLink
            to={CONFIGURATION_ROUTER_URL.NOTIFICATION_INDEX}
            className={
              isActive(CONFIGURATION_PREPEND)
                ? "menu-title active"
                : "menu-title"
            }
          >
            <img src="assets/images/icon/setting.svg" alt="" />
            Configuration
          </NavLink>
        </li>

        <li>
          <NavLink
            to={STAFF_ROUTER_URL.BUTTON_PRIORITY}
            state={{ userRole: UserTypes.Staff }}
            className={
              isActive(STAFF_PREPEND) ? "menu-title active" : "menu-title"
            }
          >
            <img src="assets/images/icon/people.svg" alt="" />
            Staff Settings
          </NavLink>
        </li>
        {user.currentCollege.managementType !=
          collegeType.universityAdministration && (
          <li>
            <NavLink
              to={FACULTY_ROUTER_URL.REPORT_PRIORITY}
              state={{ userRole: UserTypes.Faculty }}
              className={
                isActive(FACULTY_PREPEND) ? "menu-title active" : "menu-title"
              }
            >
              <img src="assets/images/icon/user.svg" alt="" />
              Faculty Settings
            </NavLink>
          </li>
        )}
        <li>
          <NavLink
            to={ROUTER_URL.FEEDBACK}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="assets/images/icon/feedback.svg" alt="" />
            Feedback
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.ADMIN_SETTINGS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="assets/images/icon/setting.svg" alt="" />
            Settings
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.INSTRUCTIONS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            <img src="/assets/images/icon/help.svg" alt="" /> Help
          </NavLink>
        </li>
      </ul>
      <div className="poweredby">
        <a
          href="https://www.buduportal.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/images/budu.png" alt="" />
          Powered by Budu Portal{" "}
        </a>
        <p className="version">Version 2.0.0</p>
        <p className="copyrights">
          &copy; 2025 Budu Portal. All rights reserved.
        </p>
      </div>
    </>
  );
};
const mapDispatchToProps = {
  logout: () => logoutUser(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
    user: state.userDetails.userProfileData,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepartmentAdminMenu);
